"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isFunction = isFunction;
function isFunction(x) {
    return typeof x === 'function';
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/util/isFunction.js
// module id = 149
// module chunks = 177